import sanitizer from 'sanitizer';
export default ({ data }) =>
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: sanitizer.sanitize(JSON.stringify({ '@context': 'http://schema.org', ...data })) }}
  />;
